function printPageExceptElement() {
    const blogTitle = document.getElementById('blog_title');
    const blogContent = document.getElementById('blog_content');
    if (!blogTitle || !blogContent) {
        console.error('Print: blog title or content not found');
        return;
    }
    const hero = document.getElementById('blog_hero');

    const previous = document.getElementById('blog-print-frame');
    if (previous) { previous.remove(); }

    const frame = document.createElement('iframe');
    frame.id = 'blog-print-frame';
    frame.setAttribute('aria-hidden', 'true');
    frame.tabIndex = -1;
    frame.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden;';
    document.body.appendChild(frame);

    const doc = frame.contentDocument;
    doc.open();
    doc.write('<!doctype html><html><head><meta charset="utf-8"><title></title><style>' +
        'body{margin:0;padding:24px;font-family:Montserrat,Arial,sans-serif;color:#000;background:#fff;line-height:1.5;}' +
        'img,video,iframe{max-width:100%;height:auto;}' +
        '#blog_hero{width:100%;max-height:300px;object-fit:cover;margin-bottom:20px;}' +
        'h1{font-size:28px;margin:0 0 16px;}' +
        'a{color:#000;}' +
        '</style></head><body></body></html>');
    doc.close();
    doc.title = document.title;

    [hero, blogTitle, blogContent].forEach(function (el) {
        if (!el) { return; }
        const clone = doc.importNode(el, true);
        clone.removeAttribute('class');
        clone.removeAttribute('style');
        doc.body.appendChild(clone);
    });

    const images = Array.prototype.slice.call(doc.images);
    images.forEach(function (img) { img.removeAttribute('loading'); });
    const ready = images.map(function (img) {
        if (img.complete) { return Promise.resolve(); }
        return new Promise(function (resolve) {
            img.addEventListener('load', resolve, { once: true });
            img.addEventListener('error', resolve, { once: true });
        });
    });
    const cap = new Promise(function (resolve) { setTimeout(resolve, 5000); });

    Promise.race([Promise.all(ready), cap]).then(function () {
        const win = frame.contentWindow;
        if (!win) { return; }
        win.addEventListener('afterprint', function () { frame.remove(); }, { once: true });
        win.focus();
        win.print();
    });
}

function getBlogLink() {
    return encodeURIComponent(window.location.href);
}

function getBlogTitle() {
    const blogTitle = document.getElementById('blog_title');
    return blogTitle ? encodeURIComponent(blogTitle.textContent) : 'Blog Post';
}

function shareWhatsappBlog() {
    const link = getBlogLink();
    const url = 'https://api.whatsapp.com/send?text=' + link;
    window.open(url, '_blank');
}

function shareTelegramBlog() {
    const link = getBlogLink();
    const title = getBlogTitle();
    const url = 'https://t.me/share/url?url=' + link + '&text=' + title;
    window.open(url, '_blank');
}

function shareFacebookBlog() {
    const link = getBlogLink();
    const url = 'https://www.facebook.com/sharer/sharer.php?u=' + link;
    window.open(url, '_blank');
}

function shareEmailBlog() {
    const link = getBlogLink();
    const title = getBlogTitle();
    const mailtoLink = 'mailto:?subject=' + title + '&body=' + link;
    window.location.href = mailtoLink;
}

function copyLinkToClipboardBlog() {
    const url = window.location.href;
    navigator.clipboard.writeText(url).then(() => {
        const feedback = document.getElementById('copy-feedback');
        if (feedback) {
            feedback.classList.remove('d-none');
            setTimeout(() => {
                feedback.classList.add('d-none');
            }, 2000);
        }
    }).catch(err => console.error('Copy failed:', err));
}